// LivestreamIndex.js
'use client';
import { connect } from 'react-redux';

import getListData from '../selector/getListData.js';
import getMeData from '../selector/getMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getIsRemoteConfigMerged from '../selector/getIsRemoteConfigMerged.js';
import { getSelectedQueryOptionObject } from '../selector/getFeedQueryObject.js';
import getFeedRenewData from '../selector/getFeedRenewData.js';
import getSelectedFeedQueryOptions from '../selector/getSelectedFeedQueryOptions.js';
import withRouter from '../component/WithRouter.jsx';

import fetchFeeds from '../action/fetchFeeds.js';

import LivestreamIndex from '../page/LivestreamIndex.jsx';

import {
  CONFIG_PRIORITY_CONFIGURE,
  CONFIG_PRIORITY_PRESENCE_USER,
  CONFIG_PRIORITY_PRESENCE_CLIENT,
} from '../resource/configPriority.js';
import { FeedNameType } from '../resource/feedConstants.js';
import { sanitizeFeedQuery } from '../resource/feedUtils.js';

import {
  LIVESTREAM_FEED,
  LIVESTREAM_FEED_SORTINGS,
} from '../RemoteConfigKeys.js';

const mapStateToProps = (
  state,
  {
    match: {
      params: { index },
    },
  }
) => {
  const isAuthed = !!getMeData(state, 'id');
  const category = getRemoteConfigData(state, LIVESTREAM_FEED);
  const isRemoteConfigMerged = isAuthed
    ? getIsRemoteConfigMerged(state, CONFIG_PRIORITY_PRESENCE_USER)
    : getIsRemoteConfigMerged(state, CONFIG_PRIORITY_PRESENCE_CLIENT) ||
      getIsRemoteConfigMerged(state, CONFIG_PRIORITY_CONFIGURE);
  const { feedNameWithQuery, intersectedFeedName } =
    getSelectedQueryOptionObject(
      state,
      category,
      getSelectedFeedQueryOptions(state, LIVESTREAM_FEED, undefined),
      getRemoteConfigData(state, LIVESTREAM_FEED_SORTINGS)?.[0]
    );

  const sanitizedFeedNameWithQuery = sanitizeFeedQuery({
    feedName: feedNameWithQuery,
  });

  const userIds = getListData(
    state,
    ['home', FeedNameType.USERS, sanitizedFeedNameWithQuery],
    'itemIds'
  );

  return {
    index: +index,
    isAuthed,
    isRemoteConfigMerged,
    feedNameWithQuery,
    intersectedFeedName,
    renewFeedId: getFeedRenewData(state, intersectedFeedName, 'id'),
    latestFeedRenewUnix: getFeedRenewData(
      state,
      intersectedFeedName,
      'timestamp'
    ),
    userIds,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFeeds: payload => dispatch(fetchFeeds(payload)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LivestreamIndex)
);
